import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="magic-link"
export default class extends Controller {
  handleSuccess(event) {
    const response = event.detail[0]
    const button = event.target
    
    if (response.status === "success") {
      // Update button to show success state
      button.innerHTML = '✅ Email Sent!'
      button.classList.remove('bg-green-600', 'hover:bg-green-700')
      button.classList.add('bg-gray-400')
      button.disabled = true
      
      // Show success message
      this.showMessage(response.message, 'success')
      
      // Reset button after 5 seconds
      setTimeout(() => {
        button.innerHTML = 'Send Verification Email'
        button.classList.remove('bg-gray-400')
        button.classList.add('bg-green-600', 'hover:bg-green-700')
        button.disabled = false
      }, 5000)
    }
  }

  handleError(event) {
    const response = event.detail[0]
    this.showMessage(response.message || 'Failed to send verification email', 'error')
  }

  showMessage(message, type) {
    // Create or update message element
    let messageEl = document.getElementById('magic-link-message')
    
    if (!messageEl) {
      messageEl = document.createElement('div')
      messageEl.id = 'magic-link-message'
      messageEl.className = 'mt-4 p-3 rounded-lg text-sm'
      
      // Insert after the button's parent div
      const buttonContainer = document.querySelector('[data-controller="magic-link"]').closest('div')
      buttonContainer.parentNode.insertBefore(messageEl, buttonContainer.nextSibling)
    }
    
    // Update styles and content based on type
    if (type === 'success') {
      messageEl.className = 'mt-4 p-3 rounded-lg text-sm bg-green-100 border border-green-300 text-green-800'
      messageEl.innerHTML = `
        <div class="flex items-center">
          <svg class="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
          ${message}
        </div>
      `
    } else {
      messageEl.className = 'mt-4 p-3 rounded-lg text-sm bg-red-100 border border-red-300 text-red-800'
      messageEl.innerHTML = `
        <div class="flex items-center">
          <svg class="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          ${message}
        </div>
      `
    }
    
    // Auto-hide after 10 seconds
    setTimeout(() => {
      if (messageEl && messageEl.parentNode) {
        messageEl.remove()
      }
    }, 10000)
  }
}